import React from 'react';

export function Statistiques(): React.ReactElement {
  return <em>Page de Statistiques pas encore implémentée</em>;
}
